
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30400',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30400",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54754",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8081",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11538",
  "I18n": "static-7.1633",
  "quartz": "static-1.7107",
  "quartz-config": "static-1.885",
  "quartz-core": "static-1.6326",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.809",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54741",
  "feedback-utils": "static-1.54745",
  "forms-embed-utils-lib": "static-1.4528",
  "forms-utils-lib": "static-1.12705",
  "foundations-assets": "static-1.4934",
  "foundations-components": "static-1.8055",
  "foundations-theming": "static-1.4490",
  "hub-http": "static-1.6285",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11845",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3967",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16743",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5393",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57666",
  "transmute": "static-2.85",
  "ui-images": "static-2.1169",
  "UIComponents": "static-3.8484",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3449",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3384",
  "quartz-webpack": "static-1.3331",
  "foundations-theming-specialty": "static-1.2206",
  "property-description-translator": "static-1.3904",
  "HeadJS": "static-2.765",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3192",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4390",
  "jasmine-runner": "static-1.6527",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4700",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.782",
  "quartz-head": "static-1.772",
  "quartz-i18n": "static-1.782",
  "quartz-routing": "static-1.537",
  "quartz-test": "static-1.782",
  "quartz-tracking": "static-1.486",
  "trellis-components": "static-1.2118",
  "ui-fonts": "static-1.800",
  "usage-tracker-container": "static-1.7403",
  "usage-tracker-core": "static-1.7263",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7313",
  "reference-resolvers": "static-1.8236",
  "sanitize-text": "static-1.8208",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10428",
  "sanitize": "static-1.4541",
  "outpost": "static-1.4238",
  "rpc-client-utils": "static-1.4718",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4324",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9486",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2099",
  "bend-plugin-foundations-theming": "static-1.2973",
  "foundations-theming-base": "static-1.3475",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.130",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9127",
  "atom": "static-1.5139",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7851",
  "ContentUtils": "static-1.68557",
  "data-token-picker": "static-1.16518",
  "file-manager-components": "static-1.23791",
  "FileManagerCore": "static-1.39290",
  "FileManagerLib": "static-1.39431",
  "frontend-preferences-client": "static-1.7990",
  "hub-http-contrib": "static-1.3105",
  "interframe": "static-3.4824",
  "layout-dnd-components": "static-1.12569",
  "layout-dnd-utils": "static-1.11544",
  "property-translator": "static-1.5460",
  "react-codemirror": "static-1.10692",
  "react-colorpicker": "static-2.10273",
  "reference-resolvers-lite": "static-1.8162",
  "rich-text-lib": "static-1.19937",
  "tinymce-data": "static-1.40637",
  "tinymce-themes": "static-1.56522",
  "ui-addon-emoji-picker": "static-1.9951",
  "ui-addon-sales-email": "static-1.5275",
  "ui-brand-identity-lib": "static-1.15526",
  "bender-build-tools": "static-1.3260",
  "hub-http-shared-msw-handlers": "static-1.10118",
  "hubspotter-http-shared-msw-handlers": "static-1.10116",
  "usage-tracker-session-replay": "static-1.5099",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1000",
  "tanstack-virtual": "static-1.31",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.128",
  "chirp-fetch": "static-1.1951",
  "chatspot-core": "static-1.21601",
  "copilot-toolkit": "static-1.11309",
  "customer-data-objects-ui-components": "static-1.13096",
  "data-fetching-client": "static-1.9727",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4824",
  "ui-addon-video-player": "static-1.8768",
  "ui-coaching-tips": "static-1.28746",
  "usage-tracker": "static-1.7413",
  "cms-field-types": "static-1.4877",
  "content-icons-ui": "static-1.2244",
  "integrations-lib": "static-1.16379",
  "customer-data-objects": "static-1.7742",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4716",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4218",
  "ui-addon-iframeable": "static-1.9126",
  "video-components-external": "static-1.11503",
  "video-data-lib": "static-1.35161",
  "audio-components": "static-1.6010",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29414",
  "FileManagerImages": "static-1.36942",
  "foundations-components-legacy": "static-1.1080",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9055",
  "urlinator": "static-1.4601",
  "video-components": "static-1.13505",
  "video-embed": "static-1.35995",
  "ts-schema": "static-1.4129",
  "ContentData": "static-1.68632",
  "layout-data-lib": "static-1.9869",
  "react-dnd-compat": "static-1.4678",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1606",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6954",
  "hs-promise-utils": "static-1.5655",
  "inbound-db-properties-service-client": "static-1.3893",
  "NamespacedHubStyle": "static-2.9107",
  "growth-onboarding-confetti": "static-1.3131",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11215",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.896",
  "magpie-lib": "static-1.5595",
  "magpie-types": "static-1.5055",
  "simple-logging-lib": "static-1.3114",
  "avatar-components": "static-1.2561",
  "customer-data-ui-utilities": "static-1.9889",
  "growth-onboarding-feedback-components": "static-1.6643",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4942",
  "integrations-error-boundary-lib": "static-1.13794",
  "integrations-tracking-lib": "static-1.5670",
  "laboratory-lib": "static-3.7219",
  "native-integrations-shared-strings": "static-1.7846",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10283",
  "unified-auth": "static-1.569",
  "navigation-messaging": "static-1.7521",
  "content-media-composition-data-lib": "static-1.12548",
  "content-media-compositions": "static-2.16555",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19036",
  "unified-auth-core-lib": "static-1.851",
  "social-insights-client-types": "static-1.22263",
  "advanced-menus-core": "static-1.15230",
  "advanced-menus-lib": "static-1.12161",
  "ExportDialog": "static-6.10448",
  "ui-memberships-settings-lib": "static-1.34226",
  "conditional-properties-service-client": "static-1.3846",
  "crm-pipelines-api-client-types": "static-1.4188",
  "fdsr-migration-layer": "static-1.73",
  "framework-builder-read-service-client": "static-1.4054",
  "framework-data-schema-quick-fetch": "static-1.6859",
  "inbound-db-meta-service-client": "static-1.3635",
  "multi-currency-client-types": "static-1.3741",
  "persist-promise": "static-1.3763",
  "foundations-components-test-utils": "static-1.5538",
  "breeze-engine-core": "static-1.174",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.789",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.401",
  "universal-page-editor-lib": "static-1.3082",
  "ads-unified-auth-lib": "static-1.120",
  "google-sheets-integration-lib": "static-1.430",
  "microsoft-drive-integration-lib": "static-1.570",
  "slack-ui-library": "static-1.10456",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3793",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15229",
  "simple-menus-lib": "static-1.16746",
  "crm-record-cards-service-types": "static-1.3639",
  "location-customization-utils-lib": "static-1.9454",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30400",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54754",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8081",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11538",
  "I18n": "/I18n/static-7.1633",
  "quartz": "/quartz/static-1.7107",
  "quartz-config": "/quartz-config/static-1.885",
  "quartz-core": "/quartz-core/static-1.6326",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.809",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54741",
  "feedback-utils": "/feedback-utils/static-1.54745",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4528",
  "forms-utils-lib": "/forms-utils-lib/static-1.12705",
  "foundations-assets": "/foundations-assets/static-1.4934",
  "foundations-components": "/foundations-components/static-1.8055",
  "foundations-theming": "/foundations-theming/static-1.4490",
  "hub-http": "/hub-http/static-1.6285",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11845",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3967",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16743",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5393",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57666",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1169",
  "UIComponents": "/UIComponents/static-3.8484",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3449",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3384",
  "quartz-webpack": "/quartz-webpack/static-1.3331",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2206",
  "property-description-translator": "/property-description-translator/static-1.3904",
  "HeadJS": "/HeadJS/static-2.765",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3192",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4390",
  "jasmine-runner": "/jasmine-runner/static-1.6527",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4700",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.782",
  "quartz-head": "/quartz-head/static-1.772",
  "quartz-i18n": "/quartz-i18n/static-1.782",
  "quartz-routing": "/quartz-routing/static-1.537",
  "quartz-test": "/quartz-test/static-1.782",
  "quartz-tracking": "/quartz-tracking/static-1.486",
  "trellis-components": "/trellis-components/static-1.2118",
  "ui-fonts": "/ui-fonts/static-1.800",
  "usage-tracker-container": "/usage-tracker-container/static-1.7403",
  "usage-tracker-core": "/usage-tracker-core/static-1.7263",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7313",
  "reference-resolvers": "/reference-resolvers/static-1.8236",
  "sanitize-text": "/sanitize-text/static-1.8208",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10428",
  "sanitize": "/sanitize/static-1.4541",
  "outpost": "/outpost/static-1.4238",
  "rpc-client-utils": "/rpc-client-utils/static-1.4718",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4324",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9486",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2099",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2973",
  "foundations-theming-base": "/foundations-theming-base/static-1.3475",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.130",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9127",
  "atom": "/atom/static-1.5139",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7851",
  "ContentUtils": "/ContentUtils/static-1.68557",
  "data-token-picker": "/data-token-picker/static-1.16518",
  "file-manager-components": "/file-manager-components/static-1.23791",
  "FileManagerCore": "/FileManagerCore/static-1.39290",
  "FileManagerLib": "/FileManagerLib/static-1.39431",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7990",
  "hub-http-contrib": "/hub-http-contrib/static-1.3105",
  "interframe": "/interframe/static-3.4824",
  "layout-dnd-components": "/layout-dnd-components/static-1.12569",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11544",
  "property-translator": "/property-translator/static-1.5460",
  "react-codemirror": "/react-codemirror/static-1.10692",
  "react-colorpicker": "/react-colorpicker/static-2.10273",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8162",
  "rich-text-lib": "/rich-text-lib/static-1.19937",
  "tinymce-data": "/tinymce-data/static-1.40637",
  "tinymce-themes": "/tinymce-themes/static-1.56522",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9951",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5275",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15526",
  "bender-build-tools": "/bender-build-tools/static-1.3260",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10118",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10116",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5099",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1000",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.128",
  "chirp-fetch": "/chirp-fetch/static-1.1951",
  "chatspot-core": "/chatspot-core/static-1.21601",
  "copilot-toolkit": "/copilot-toolkit/static-1.11309",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13096",
  "data-fetching-client": "/data-fetching-client/static-1.9727",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4824",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8768",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28746",
  "usage-tracker": "/usage-tracker/static-1.7413",
  "cms-field-types": "/cms-field-types/static-1.4877",
  "content-icons-ui": "/content-icons-ui/static-1.2244",
  "integrations-lib": "/integrations-lib/static-1.16379",
  "customer-data-objects": "/customer-data-objects/static-1.7742",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4716",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4218",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9126",
  "video-components-external": "/video-components-external/static-1.11503",
  "video-data-lib": "/video-data-lib/static-1.35161",
  "audio-components": "/audio-components/static-1.6010",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29414",
  "FileManagerImages": "/FileManagerImages/static-1.36942",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1080",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9055",
  "urlinator": "/urlinator/static-1.4601",
  "video-components": "/video-components/static-1.13505",
  "video-embed": "/video-embed/static-1.35995",
  "ts-schema": "/ts-schema/static-1.4129",
  "ContentData": "/ContentData/static-1.68632",
  "layout-data-lib": "/layout-data-lib/static-1.9869",
  "react-dnd-compat": "/react-dnd-compat/static-1.4678",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1606",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6954",
  "hs-promise-utils": "/hs-promise-utils/static-1.5655",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3893",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9107",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3131",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11215",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.896",
  "magpie-lib": "/magpie-lib/static-1.5595",
  "magpie-types": "/magpie-types/static-1.5055",
  "simple-logging-lib": "/simple-logging-lib/static-1.3114",
  "avatar-components": "/avatar-components/static-1.2561",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9889",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6643",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4942",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13794",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5670",
  "laboratory-lib": "/laboratory-lib/static-3.7219",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7846",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10283",
  "unified-auth": "/unified-auth/static-1.569",
  "navigation-messaging": "/navigation-messaging/static-1.7521",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12548",
  "content-media-compositions": "/content-media-compositions/static-2.16555",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19036",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.851",
  "social-insights-client-types": "/social-insights-client-types/static-1.22263",
  "advanced-menus-core": "/advanced-menus-core/static-1.15230",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12161",
  "ExportDialog": "/ExportDialog/static-6.10448",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34226",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3846",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4188",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.73",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4054",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6859",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3635",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3741",
  "persist-promise": "/persist-promise/static-1.3763",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5538",
  "breeze-engine-core": "/breeze-engine-core/static-1.174",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.789",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.401",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3082",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.120",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.430",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.570",
  "slack-ui-library": "/slack-ui-library/static-1.10456",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3793",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15229",
  "simple-menus-lib": "/simple-menus-lib/static-1.16746",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3639",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9454",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
